import React from 'react'
import patternRight from '../../../common/images/gridPatternRight.png'
import patternLeft from '../../../common/images/gridPatternLeft.png'
import { Box, Button, Stack, Typography } from '@mui/material'

export default function BlockWrapper({ blockName, icon, content, buttonName, rightSideImage, onClick }) {
  return (
    <Box sx={containerSx}>
      <Box flex={1} sx={leftPreviewPaneSx}>
        <Stack rowGap={3}>
          <Box display={'flex'} columnGap={1} alignItems={'center'}>
            {icon} <Typography sx={blockNameSx}>{blockName}</Typography>
          </Box>
          <Typography sx={contentSx}>{content}</Typography>
        </Stack>
        <Button variant='contained' size='small' sx={buttonSx} onClick={onClick}>
          {buttonName}
        </Button>
      </Box>
      <Box sx={rightPreviewPaneSx}>
        <Box component='img' alt='pattern-left' src={patternLeft} sx={imagePatternSx('bottomLeft')} />
        <Box component='img' alt='pattern-right' src={patternRight} sx={imagePatternSx('topRight')} />

        {rightSideImage ? (
          <Box sx={wrapperSx}>
            <img src={rightSideImage} alt={blockName} style={imgStyle} />
          </Box>
        ) : (
          <Box sx={wrapperSx}>
            <Typography variant='subtitle1' color='textSecondary'>
              Image not available
            </Typography>
          </Box>
        )}
      </Box>
    </Box>
  )
}

const containerSx = {
  display: 'flex',
  borderRadius: '20px',
  width: '100%',
  padding: 4,
  background: ' #FFFFFF',
  border: '2px solid #DBDBE6'
}
const leftPreviewPaneSx = {
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  flex: 1,
  maxHeight: '500px',
  overflowY: 'auto',
  pr: 1
}

const rightPreviewPaneSx = {
  flex: 1,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  paddingLeft: 2,
  borderLeft: '1px solid #DDDDDD',
  minHeight: '400px',
  position: 'relative',
  overflow: 'hidden',
  backgroundColor: '#fff'
}

const imagePatternSx = position => ({
  position: 'absolute',
  width: '300px',
  height: 'auto',
  zIndex: 0,
  ...(position === 'topRight' && { top: -20, right: 0 }),
  ...(position === 'bottomLeft' && { bottom: -20, left: -30 })
})

const wrapperSx = {
  zIndex: 1,
  position: 'relative',
  width: '100%',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  padding: 2
}
const blockNameSx = {
  fontFamily: "'Plus Jakarta Sans'",
  fontWeight: 600,
  fontSize: '16px',
  color: '#76767D'
}
const contentSx = {
  fontFamily: "'Plus Jakarta Sans'",
  fontWeight: 600,
  fontSize: '20px',
  color: '#1B1B26'
}
const imgStyle = { maxWidth: '300px', maxHeight: '300px', objectFit: 'contain' }
const buttonSx = {
  borderRadius: '16px',
  fontFamily: 'Plus Jakarta Sans',
  fontWeight: 400,
  fontSize: '16px',
  padding: '8px 8px',
  backgroundColor: '#0246F8',
  boxShadow: 'none',
  color: '#fff',
  textTransform: 'none',
  width: '100%',
  minWidth: '180px',
  maxWidth: '240px',
  '&:hover': { backgroundColor: '#1d4ed8' },
  '&.Mui-disabled': {
    backgroundColor: '#e0e0e0',
    color: '#757575'
  }
}
